import template from './loanFactFind.html';

export default {
  template,
  controllerAs: 'vm',
  bindings: {
    loanDetails: '<',
    lendingDetailScope: '<',
    loanDetailScope: '<',
  },
};
